import React from 'react'
import "../Fireworks/Fireworks.css"
function Fireworks() {
  return (
    <div>
      <div className="pyro">
        <div className="before"></div>
        <div className="after"></div>
      </div>
    </div>
  )
}

export default Fireworks